
<template>
    <div class="desktop">
        <h4 class="desk_title">{{ModalName}}</h4>
        <div class="app-container">
            <div class="filter-container">
                <el-row :gutter="20">
                    <el-col :span="6"  style="width:100%;">
                        <div class="t-table"  style="width:100%;">
                            <div class="t-input"  style="display:flex;width:100%;align-items: center;">
                                 <div style="margin-right:30px;font-size:14px;"> {{g('$订单号/跟踪号/参考号/收件人')}}</div>
                                <el-input v-model="OrderPage.SearchEntity.ONs2" type="text" style="width:70%;" :autosize="{minRows:1,maxRows:30}"></el-input>
                            </div>
                        </div>
                    </el-col>

                      <el-col :span="6" style="width:100%;margin-top:30px;">
                        <div class="t-table" style="width:100%;">
                            <div class="t-input" style="display:flex;width:100%;align-items: center;">
                                <div style="margin-right:30px;font-size:14px;"> {{g('$SKU')}} </div>
                                <el-input v-model="OrderPage.SearchEntity.SKUList" type="text" style="width:78%;" :autosize="{minRows:1,maxRows:30}"></el-input>
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="18"  class="order-search" style="margin-top:40px;width:100%;padding-left:80px;"  v-show="showOrderSearchData">
                        <page-search-table :store="OrderPage" :fieldData="OrderPage.SearchEntity" class="page_search_table orderListTable"></page-search-table>
                    </el-col>
                    <el-col>
                    <el-button class="filter-item" @click="showOrderSearch" type="primary" style="margin-top:30px;">{{showOrderSearchData?gets('$隐藏更多搜索项'):gets('$展开更多搜索项')}}</el-button>
                    </el-col>
                </el-row>
                <div class="clearfix"></div>
                <div class="comd orderListComd" style="float: right;padding-top:0px;margin-bottom:10px;">
                    <el-button class="filter-item" v-if="isSee" type="primary" @click="OrderPage.Table.OnPageChange(1,this)" icon="el-icon-search">{{gets('$查询')}}</el-button>
                    
                     <form method="post" style="display:none" :action="(Urlpath == '/' ? '' : Urlpath)+'/Api/Order/SearchOrderWeightLists'" :id="OrderPage.GN('SearchOrder')+'FormRepeat'">
                        <input name="datas" :id="OrderPage.GN('SearchOrder')+'FormDataRepeat'">
                    </form>
                    <el-button class="filter-item" v-if="isSee" type="primary" @click="ToExportOrderRepeat" icon="el-icon-download">{{gets('$导出计费重量')}}</el-button>
                    
                    <form method="post" style="display:none" :action="(Urlpath == '/' ? '' : Urlpath)+'/Api/Order/ExportOrder'" :id="OrderPage.GN('SearchOrder')+'Form'">
                        <input name="datas" :id="OrderPage.GN('SearchOrder')+'FormData'">
                    </form>
                    <el-button class="filter-item" v-if="isSee" type="primary" @click="ToExportOrder" icon="el-icon-download">{{gets('$导出')}}</el-button>
                    <form method="post" style="display:none" :action="(Urlpath == '/' ? '' : Urlpath)+'/Api/Order/ExportOrderLess'" :id="OrderPage.GN('SearchOrder')+'Formless'">
                        <input name="datas" :id="OrderPage.GN('SearchOrder')+'FormDataless'">
                    </form>

                       <form method="post" style="display:none" :action="(Urlpath == '/' ? '' : Urlpath)+'/Api/Order/ExportOrderALL'" :id="OrderPage.GN('SearchOrder')+'ExportOrderALL'">
                        <input name="datas" :id="OrderPage.GN('SearchOrder')+'ExportOrderALLS'">
                    </form>
            <el-button class="filter-item" v-if="isSee" type="primary" @click="ToExportOrderALL" icon="el-icon-download">{{gets('$导出所有')}}</el-button>
                      <!-- <el-button class="filter-item" v-if="isSee" type="primary" @click="ToExportOrderLess" icon="el-icon-download">{{gets('$导出缺货信息')}}</el-button> -->
                    <el-button class="filter-item" v-if="isUpdate" @click="ToMarkingOrder(OrderPage)" style="margin-left: 10px;" type="primary" icon="el-icon-edit">{{gets('$标记')}}</el-button>
                    <el-button class="filter-item" v-if="isUpdate" @click="ToRemarkOrder(OrderPage)" style="margin-left: 10px;" type="primary" icon="el-icon-edit">{{gets('$备注')}}</el-button>
                    <el-button class="filter-item" v-if="isUpdate" type="primary" @click="UpdateTrackNos" icon="el-icon-refresh">{{gets('$批量更新跟踪号')}}</el-button>

  <el-button class="filter-item" v-if="isUpdate" type="primary" @click="UpdateYUNTU" icon="el-icon-refresh">{{gets('$更新云途单号')}}</el-button>
  <el-button class="filter-item"  type="success" @click="OrderPage.AddModuleShow2=true">{{gets('$拦截订单(菜鸟)')}}</el-button>
    <el-button class="filter-item" v-if="isSee" type="primary" @click="OrderPage.AddModuleShow5=true" icon="el-icon-download">{{gets('$多状态导出')}}</el-button>
    <el-button class="filter-item" v-if="isSee" type="primary" @click="OrderPage.ShouBtnExport=true" icon="el-icon-download">{{gets('$选择列导出')}}</el-button>
    
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="desk_title OrderListVueDT" style="height:auto">
            <el-tabs v-model="OrderStatus" @tab-click="handleClick">
               
                <el-tab-pane :label="gets('$确认')+'('+GetCountByStatus(1)+')'" :name="'1'">
                </el-tab-pane>
                 <el-tab-pane :label="gets('$已迁入')+'('+GetCountByStatus(2)+')'" :name="'2'">
                </el-tab-pane>
                <el-tab-pane :label="gets('$处理中')+'('+GetCountByStatus(7)+')'" :name="'7'">
                    <el-button class="filter-item" v-if="isSee" @click="ToPrintPOrder(OrderPage)" style="margin-left: 10px;" type="primary" icon="el-icon-edit">{{gets('$打印派送标签')}}</el-button>
                </el-tab-pane>
              
                <el-tab-pane :label="gets('$已付款待发货')+'('+GetCountByStatus(3)+')'" :name="'3'">
                </el-tab-pane>
                <el-tab-pane :label="gets('$已发货')+'('+GetCountByStatus(4)+')'" :name="'4'">
                </el-tab-pane>
                <el-tab-pane :label="gets('$缺货')+'('+GetCountByStatus(6)+')'" :name="'6'">
                </el-tab-pane>
                <el-tab-pane :label="gets('$问题件')+'('+GetCountByStatus(5)+')'" :name="'5'">
                </el-tab-pane>
                <el-tab-pane :label="gets('$已作废')+'('+GetCountByStatus(10)+')'" :name="'10'">
                </el-tab-pane>
                <el-tab-pane :label="gets('$草稿')+'('+GetCountByStatus(0)+')'" :name="'0'">
                </el-tab-pane>

                  <el-tab-pane :label="gets('$预报中')+'('+GetCountByStatus(9)+')'" :name="'9'">

                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="clearfix"></div>
        <div id="page_content">
            <l-table-page-view class="orderListBG"  :resultData="$store.state[OrderPage.GN('SearchOrder')]" :TableConfig="OrderPage.Table"></l-table-page-view>
        </div>
      

        <!--选择列导出 -->

        <el-dialog :visible.sync="OrderPage.ShouBtnExport" :al-append-to-body="true" :append-to-body="true" width="800" :title="gets('$选择导出列')">
          
            
             <div class="checkbox-container">
              <div v-for="item in $store.state[OrderPage.GN('OrderChoose')]" :key="item.EnName" class="checkbox-item">
                <label>
                    <input type="checkbox" v-model="item.Chooses" class="hidden-checkbox" />
                    <span class="checkbox-custom"></span>
                    {{ lang=="EN"?item.EnName:item.CnName }}
                </label>
              </div>
             </div>      
            <div slot="footer">
               <el-button type="primary" size="large" @click="selectAll">{{ gets('$全部选中') }}</el-button>
               <el-button type="primary" size="large" @click="unselectAll">{{ gets('$全部取消') }}</el-button>

              

                
                <el-button type="primary" size="large"  @click="ToChooseExportOrder">{{gets('$导出')}}</el-button>
           
            <form method="post" style="display:none" :action="(Urlpath == '/' ? '' : Urlpath)+'/Api/Order/NewExportOrders'" :id="OrderPage.GN('SearchOrder')+'NewExclFrom'">
                <input name="datas" :id="OrderPage.GN('SearchOrder')+'NewFormData'">
            </form>
            </div>
        </el-dialog>


        <!-- 导出多状态订单  -->
        <el-dialog :visible.sync="OrderPage.AddModuleShow5" :modal-append-to-body="true" :append-to-body="true" width="800" :title="gets('$订单多选状态导出')">
            <!-- <form-list :store="OrderPage" :entity="OrderPage.Entity"></form-list> -->
            <form-list :fieldData="OrderPage.Search2" :entity="OrderPage.Search2"></form-list>
            <form method="post" style="display:none" :action="(Urlpath == '/' ? '' : Urlpath)+'/Api/Order/ExportOrder'" :id="OrderPage.GN('SearchOrder')+'Form2'">
                <input name="datas" :id="OrderPage.GN('SearchOrder')+'FormData2'">
            </form>
            <div slot="footer">
                <el-button type="text" size="large" @click="OrderPage.AddModuleShow5 =false">{{gets('$取消')}}</el-button>
                <el-button type="primary" size="large"  @click="ToExportOrder2">{{gets('$导出')}}</el-button>
            </div>
        </el-dialog>
        <!-- 批量修改  -->
        <el-dialog :visible.sync="OrderPage.AddModuleShow" :modal-append-to-body="true" :append-to-body="true" width="800" :title="gets('$批量修改')">
            <form-list :store="OrderPage" :entity="OrderPage.Entity"></form-list>
            <div slot="footer">
                <el-button type="text" size="large" @click="OrderPage.AddModuleShow =false">{{gets('$取消')}}</el-button>
                <el-button type="primary" size="large" v-if="isAdd" @click="UpdateOrders(OrderPage,this)">{{gets('$确定')}}</el-button>
            </div>
        </el-dialog>
         <!-- 菜鸟拦截订单  -->
        <el-dialog :visible.sync="OrderPage.AddModuleShow2" :modal-append-to-body="true" :append-to-body="true" width="800" :title="gets('$拦截订单')">
            <el-col :span="6"  style="width:100%;">
                        <div class="t-table"  style="width:100%;">
                            <div class="t-input"  style="display:flex;width:100%;align-items: center;">
                                 <div style="margin-right:30px;font-size:14px;"> {{g('$订单号')}}</div>
                                <el-input v-model="OrderPage.orders" type="text" style="width:90%;" ></el-input>
                            </div>
                        </div>
            </el-col>
            <div slot="footer">
                <el-button type="text" style="margin-top:20px;" size="large" @click="OrderPage.AddModuleShow2 =false,OrderPage.orders =''">{{gets('$取消')}}</el-button>
                <el-button type="primary" size="large"  @click="InterceptOredr">{{gets('$确定')}}</el-button>
            </div>
        </el-dialog>
        <!-- 合并订单  -->
        <el-dialog :modal-append-to-body="true" :append-to-body="true" :visible.sync="OrderPage.IsMergeOrder" width="800" :title="gets('$合并订单')">
            <div v-if="$store.state[OrderPage.GN('OrderTableSelectCheckbox')]">
                <p class="bg-danger">
                    <ul>
                        <li>{{gets('$请先选择一个订单作为合并的基准订单')}}
                        </li>
                    </ul>
                </p>
                <div class="page_content" id="page_content" style="display: initial;">
                    <l-table-view v-if="$store.state[OrderPage.GN('OrderTableSelectCheckbox')]" :DataArr="$store.state[OrderPage.GN('OrderTableSelectCheckbox')]" :TableConfig="OrderPage.Table2"></l-table-view>
                </div>
            </div>
            <div slot="footer">
                <el-button type="text" size="large" @click="OrderPage.IsMergeOrder =false">{{gets('$取消')}}</el-button>
                <el-button type="primary" size="large" v-if="isAdd" @click="MergeOrder(OrderPage,this)">{{gets('$确定')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :modal-append-to-body="true" :append-to-body="true" :visible.sync="OrderPage.IsCopyOrder" width="800" :title="gets('$复制订单')">
            <div>
                <p class="bg-danger">
                    <ul>
                        <li>{{gets('$请输入一个需要复制的参考号或者订单号')}}
                        </li>
                    </ul>
                </p>
                <div class="page_content" id="page_content" style="display: initial;">
                    <el-form label-position="right" label-width="150px">
                        <el-form-item :label="gets('$参考号/订单号')">
                            <span slot="label">  <span class="red" >*</span> {{gets('$参考号/订单号')}}</span>
                            <el-input v-model="CopyNo"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div slot="footer">
                <el-button type="text" size="large" @click="OrderPage.IsCopyOrder =false">{{gets('$取消')}}</el-button>
                <el-button type="primary" size="large" v-if="isAdd" @click="CopyOrder(OrderPage,this)">{{gets('$确定')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :modal-append-to-body="true" :append-to-body="true" :visible.sync="OrderPage.IsMarkingOrder" width="800" :title="gets('$标记订单')">
            <div v-if="$store.state[OrderPage.GN('OrderTableSelectCheckbox')]">
                <div class="page_content" id="page_content" style="display: initial;">
                    <div class="xgxxrow" style="padding-top: 0;">
                        <table cellpadding="0" cellspacing="0" width="100%" border="0" style="margin-bottom: 10px;">
                            <tbody>
                                <tr>
                                    <td style="width:45%;">{{gets('$标记名称')}}</td>
                                    <td style="width:45%;">{{gets('$标记颜色')}}</td>
                                    <td style="width:5%;">{{gets('$操作')}}</td>
                                </tr>
                                <tr v-for="i in $store.state[OrderPage.GN('ColorMark')]">
                                    <td style="cursor:pointer;color:#fff;" :bgcolor="i.Color">
                                        <span style="width:100%; display:block;color: rgb(255, 255, 255);" onclick="ShowEdit('1')"> {{i.Text}}</span>
                                    </td>
                                    <td nowrap="nowrap" :bgcolor="i.Color"> {{i.Color}}</td>
                                    <td>
                                        <el-button class="filter-item" @click="MarkingOrder(i.Color,i.EnName,i.CnName)" style="margin-left: 10px;" size="mini" plain type="primary" icon="el-icon-edit">{{gets('$标记')}}</el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </el-dialog>

 <!-- 提示  -->
        <el-dialog :modal-append-to-body="true" :append-to-body="true" :visible.sync="IsTips" width="800" :title="gets('$提示')">
            <div>
                <p class="bg-danger">
                    <ul>
                        <li v-html="Tips">OK
                        </li>
                    </ul>
                </p>
            </div>
            <div slot="footer">
                <el-button type="text" size="large" @click="IsTips =false">{{gets('$取消')}}</el-button>
            </div>
        </el-dialog>


        <el-dialog :modal-append-to-body="true" :append-to-body="true" :visible.sync="OrderPage.IsRemarkOrder" width="800" :title="gets('$备注订单')">
            <div class="page_content" id="page_content" style="display: initial;">
                <el-form label-position="right" label-width="150px">
                    <el-form-item :label="gets('$备注')">
                        <span slot="label">  <span class="red" >*</span> {{gets('$备注')}}</span>
                        <el-input type="textarea" v-model="Remark"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button type="text" size="large" @click="OrderPage.IsRemarkOrder =false">{{gets('$取消')}}</el-button>
                <el-button type="primary" size="large"  @click="RemarkOrder(OrderPage,this)">{{gets('$确定')}}</el-button>
            </div>
        </el-dialog>


        <el-dialog :modal-append-to-body="true" :append-to-body="true" :visible.sync="OrderPage.UploadTrackingNos.ModuleShow" width="800" :title="OrderPage.UploadTrackingNos.ModalName">
            <div style="height:45px">
                <div id="">
                    <div style="display: block;">
                        <div id="UploadTrackingNos_file_upload"  class="uploadify-button-text" style="float: left;">{{gets("$上传")}}</div>
                        <el-button size="large" @click="OrderPage.UploadTrackingNos.templateurl()" style="float:right;">{{gets("$下载导入模板")}}</el-button>
                        <div class="clearfix"></div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <div v-if="$store.state[OrderPage.GN('UploadTrackingNos_file_upload')]">
                <div class="page_content" id="page_content" style="display: initial;">
                    <l-table-view v-if="$store.state[OrderPage.GN('UploadTrackingNos_file_upload')].data" :DataArr="$store.state[OrderPage.GN('UploadTrackingNos_file_upload')].data" :TableConfig="OrderPage.UploadTrackingNos.Table"></l-table-view>
                </div>
            </div>
            <div slot="footer">
                <el-button type="text" size="large" @click="OrderPage.UploadTrackingNos.ModuleShow =false">{{gets('$取消')}}</el-button>
                <el-button type="primary" size="large" @click="function(){
                                                                    var d = $store.state[OrderPage.GN('UploadTableSelectCheckboxTrackingNos')];
                                                                    OrderPage.UploadTrackingNos.ModuleShow =false;
                                                                  OrderPage.UploadTrackingNos.Update(d,function(){
                                                                      OrderPage.SearchPageData();
                                                                  })
                         }">{{gets('$确定')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
  IsRights,
  Modulel,
  Permission,
  Clone,
  ToComponentData,
  CheckByConfig,
  ToSubmitData,
} from "@/config/config";
import gets from "@/model/language";
import { InitOrderPage } from "@/config/Order/OrderListConfig.js";
var self;

import { GetCountByStatus, GetFieldItem } from "@/lf";
import { ChannelInfoRequest } from "@/request/Channel";
export default {
  data() {
    return {
      ModalName: gets("$订单列表"),
      OrderStatus: "1",
      CopyNo: "",
      MarkingType: "",
      OrderStoreName: null,
      OrderConfig: null,
      $Urlpath: window._$Urlpath,
      Urlpath: window._$Urlpath,
      Remark: "",
      Tips: "",
      IsTips: false,
      showOrderSearchData: false, //搜索条件隐藏
      lang:window.$.cookie('LanguagesTag')
    };
  },
  created() {
    this.init();
  },
  mounted() {


    $(".gutter").css({ display: "block !important" });
  },
  computed: {
    OrderPage() {
      return this.$store.state[this.OrderStoreName];
    },
    OrderTableSelectCheckbox() {
      return this.$store.state[this.OrderPage.GN("OrderTableSelectCheckbox")];
    },
    OrderTable2SelectCheckbox() {
      return this.$store.state[this.OrderPage.GN("OrderTable2SelectCheckbox")];
    },
    isAdd() {
      return IsRights(Modulel.OrderManage, Permission.Add);
    },
    isSee() {
      return IsRights(Modulel.OrderManage, Permission.See);
    },
    isUpdate() {
      return IsRights(Modulel.OrderManage, Permission.Update);
    },
  },
  methods: {
    showOrderSearch() {
      if (this.showOrderSearchData == false) {
        this.showOrderSearchData = true;
      } else if (this.showOrderSearchData == true) {
        this.showOrderSearchData = false;
      }
    },
    GetCountByStatus(Status) {
      var os = self.$store.state[self.OrderPage.GN("SearchOrder")];

      return GetCountByStatus(Status, os ? os.StatusAndCounts : null);
    },
    init() {
      window.addEventListener("scroll", function (event) {
        var scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        if (scrollTop > 280) {
          $(".OrderListVueDT").css({
            position: "fixed",
            top: "99px",
            "margin-top": "100px",
            width: "100%",
            "z-index": "10",
          });
          $(".orderListComd").css({
            height: "57px",
            width: "100%",
            "margin-top": "0px",
            right: "0",
            "text-align": "right",
            position: "fixed",
            top: "142px",
            "padding-right": "30px",
            "z-index": "50",
            "padding-top": "10px",
          });
          $(".orderListBG").css("margin-top", "170px");
          //   $(".orderList  .el-table__header").css({"position": "fixed","z-index": "1000","top":"258px","width":"100%",})
          $(".orderListBG  .el-table__header").css({
            position: "fixed",
            "z-index": "1000",
            top: "265px",
          });
        } else {
          $(".OrderListVueDT").css({
            height: "auto",
            position: "relative",
            "z-index": "1",
            "margin-top": "0px",
            top: "0px",
          });
          $(".orderListComd").css({
            height: "50px",
            "background-color": "#F3F7F9",
            position: "relative",
            "z-index": "1",
            top: "0px",
            "padding-right": "0px",
          });
          $(".orderListBG").css({ "margin-top": "0px" });
          $(".orderListBG .el-table__header").css({
            position: "relative",
            "z-index": "1",
            top: "0px",
          });
        }
      });
      window.rootVue.setThisWindowVueComponent(this);
      self = this;
      this.OrderConfig = InitOrderPage(window.rootVue.thisWindow.tag);
      this.OrderStoreName = this.OrderConfig.storeName;
      this.OrderConfig.initPageData();
      this.OrderPage.SearchEntity.OrderStatus = 1;

      self.$set(self.OrderPage.SearchEntity, "ONs", "");
      // self.$set(self.OrderPage.SearchEntity, 'ONs2', "")
      // self.OrderPage.SearchEntity.ONs = self.OrderPage.SearchEntity.ONs2
      this.OrderPage.SearchPageData();
      this.OrderPage.initRegionCountry();
      this.OrderPage.initOrderChannelInfoID();
      //this.OrderPage.initNextCompanyNextCompanyIDByQ();

      this.OrderPage.initWarehouseWareHousesID();
      this.OrderPage.initShopCustomerShopCustomerID();

      this.OrderPage.initColorMark();
      var ds = this.OrderPage.SetOrderChoose();
   
      self.$set(self.OrderPage, "IsMergeOrder", false);
      self.$set(self.OrderPage, "IsCopyOrder", false);
      self.$set(self.OrderPage, "IsMarkingOrder", false);
      self.$set(self.OrderPage, "IsRemarkOrder", false);
      this.OrderPage.ToUpdate = function (data) {
        //列表点击修改或查看
        self.$router.push("/OrderInfo/" + data.ID);
      };
      this.OrderPage.ToUpdateStatus = function (data) {
        //列表点击修改状态 或者状态删除
        var store = self.OrderPage;
        store.Table.OnPageChange(store.SearchEntity.PageIndex, self);
      };
      this.OrderPage.ToDelete = function (data) {
        //列表点击删除
        var store = self.OrderPage;
        store.Table.OnPageChange(store.SearchEntity.PageIndex, self);
      };
      this.OrderPage.ToCountryChange = function (data) {
        self.OrderPage.initOrderChannelInfoID(data.ID);
      };
      this.OrderPage.ToChannelInfoChange = function (ID) {
        ChannelInfoRequest.SearchSubChannelInfo(
          function (d) {
            var arr = [];
            if (d.Records) {
              for (var i of d.Records) {
                i.Text = i.EnName + "(" + i.CnName + ")";
                i.Value = i.ID;
                arr.push(i);
              }
            }
            self.$set(
              self.$store.state,
              self.OrderPage.GN("OrderSubChannelInfoID"),
              arr
            );
          },
          {
            ChannelInfoID: ID,
          }
        );
      };
    },
    gets: gets,
    g: gets,
    OnBack() {
      var store = self.OrderPage;
      store.Table.OnPageChange(store.SearchEntity.PageIndex, self);
    },
    ToAddOrder() {
      self.$router.push("/OrderInfo/" + 0);
    },
    handleClick(tab, event) {
      self.OrderPage.SearchEntity.PageIndex = 1;
      console.log(self.OrderPage.SearchEntity, 11111111111);
      self.OrderPage.SearchEntity.OrderStatus = self.OrderStatus;
      self.OrderPage.SearchPageData();
      if (self.OrderStatus == 4) {
        GetFieldItem(
          "AfterShiptag",
          self.OrderPage.Table.TableColumns
        ).IsNotShow = false;
      } else {
        GetFieldItem(
          "AfterShiptag",
          self.OrderPage.Table.TableColumns
        ).IsNotShow = true;
      }
      // var pf = self.$store.state[self.ShopCustomerPage.GN('ShopCustomerPlatFormID')][tab.index]
      // console.log(pf);
      // self.ShopCustomerPage.SearchEntity.PlatFormID = pf.ID
      // self.setPlatFormJson(pf.ID)
      // self.ShopCustomerPage.SearchPageData();
    },
    ToOrderSubmit() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.OrderSubmit(
          arr,
          self.OrderPage.Table.IsSelectAll,
          self.OrderPage.SearchEntity,
          function (d) {
            self.OrderPage.SearchPageData();
          }
        );
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    ToUpdateOrders() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        self.$set(
          self.OrderPage,
          "Entity",
          ToSubmitData(ToComponentData(self.OrderPage.FieldData))
        );
        self.OrderPage.AddModuleShow = true;
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    UpdateOrders() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.UpdateOrders(arr, self.OrderPage.Entity, function (d) {
          self.OrderPage.SearchPageData();
          self.OrderPage.AddModuleShow = false;
        });
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    ToMergeOrder() {
      var b = true;
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 1
      ) {
        var c = self.OrderTableSelectCheckbox[0].CsRefNo;
        for (var i of self.OrderTableSelectCheckbox) {
          if (i.CsRefNo != c) {
            b = false;
          }
        }
        if (b) {
          self.OrderPage.IsMergeOrder = true;
        } else {
          self.$message.error(gets("$请选择客户参考号一致的订单"));
        }
      } else {
        self.$message.error(gets("$请选择至少二项订单"));
      }
    },

    UpdateYUNTU() {
      var self = this;
      var arr = [];
      self.OrderPage.UpdateYUNTU(arr, function (d) {
        self.IsTips = true;
        self.Tips = d.Message;
      });
    },
    //菜鸟拦截
    InterceptOredr() {
      var self = this;

      var arr = self.OrderPage.orders.split(/\s+/);

      self.OrderPage.InterceptOredr(arr, function (d) {
        self.OrderPage.AddModuleShow2 = false;
        self.$message.success(d);
      });
    },

    MergeOrder() {
      if (
        self.OrderTable2SelectCheckbox &&
        self.OrderTable2SelectCheckbox.length > 0
      ) {
        if (self.OrderTable2SelectCheckbox.length > 1) {
          self.$message.error(gets("$只能选择一项订单"));
          return;
        }

        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.MergeOrder(
          arr,
          self.OrderTable2SelectCheckbox[0].ID,
          function (d) {
            self.OrderPage.SearchPageData();
            self.OrderPage.IsMergeOrder = false;
          }
        );
      } else {
        self.$message.error(gets("$请选择一项订单"));
      }
    },
    ToExportOrder() {
      var self = this;
      var arr = [];
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
      }
      var exportdata = {
        IDs: arr,
        SearchEntity: self.OrderPage.SearchEntity,
        ExportAll:true
      };
      console.log(exportdata, "订单导出");
      window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "FormData"
      ).value = JSON.stringify(exportdata);
      var fm = window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "Form"
      );
      fm.submit();
      //window.open((self.Urlpath == '/' ? '' : self.Urlpath) + '/Api/Order/ExportOrder?ArrID=' + arr.join(','))
    },
    ToExportOrderRepeat() {
      var self = this;
      var arr = [];
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
      }
      var exportdata = {
        IDs: arr,
        SearchEntity: self.OrderPage.SearchEntity,
      };
      console.log(exportdata, 8888);
      window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "FormDataRepeat"
      ).value = JSON.stringify(exportdata);
      var fm = window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "FormRepeat"
      );
      fm.submit();
      //window.open((self.Urlpath == '/' ? '' : self.Urlpath) + '/Api/Order/ExportOrder?ArrID=' + arr.join(','))
    },

    selectAll() {
       
        for (const item of self.$store.state[self.OrderPage.GN("OrderChoose")]) {
            item.Chooses = true;
        }
    },
    unselectAll() {
       
        for (const item of self.$store.state[self.OrderPage.GN("OrderChoose")]) {
            item.Chooses = false;
        }
    },
    ToChooseExportOrder(){

    var data = self.$store.state[self.OrderPage.GN("OrderChoose")];
    var filteredData = data.filter(function(item) {
      return item.Chooses === true;
    });

    var self1 = this;
      var arr = [];
      if (
        self1.OrderTableSelectCheckbox &&
        self1.OrderTableSelectCheckbox.length > 0
      ) {
        for (var i of self1.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
      }
      var exportdata = {
        IDs: arr,
        SearchEntity: self1.OrderPage.SearchEntity,
        ChooseData:filteredData,
        ExportAll:false,
        language:window.$.cookie('LanguagesTag')
      };
      console.log(exportdata, "订单导出");
      window.document.getElementById(
        self1.OrderPage.GN("SearchOrder") + "NewFormData"
      ).value = JSON.stringify(exportdata);
      var fm = window.document.getElementById(
        self1.OrderPage.GN("SearchOrder") + "NewExclFrom"
      );
      fm.submit();

  
      self.OrderPage.ShouBtnExport = false;

    },
      


    ToExportOrder2() {
      self.OrderPage.SearchEntity.StatusList =
        self.OrderPage.Search2.StatusList;
      var arr = [];
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
      }
      var exportdata = {
        IDs: arr,
        SearchEntity: self.OrderPage.SearchEntity,
        
      };
      console.log(exportdata, 123456);
      window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "NewFormData"
      ).value = JSON.stringify(exportdata);
      var fm = window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "Form2"
      );
      fm.submit();
      this.OrderPage.AddModuleShow5 = false;
      //window.open((self.Urlpath == '/' ? '' : self.Urlpath) + '/Api/Order/ExportOrder?ArrID=' + arr.join(','))
    },
    ToExportOrderLess() {
      var self = this;
      var arr = [];
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
      }
      var exportdata = {
        IDs: arr,
        SearchEntity: self.OrderPage.SearchEntity,
      };
      window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "FormDataless"
      ).value = JSON.stringify(exportdata);
      var fm = window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "Formless"
      );
      fm.submit();
      //window.open((self.Urlpath == '/' ? '' : self.Urlpath) + '/Api/Order/ExportOrder?ArrID=' + arr.join(','))
    },

    ToExportOrderALL() {
      var self = this;
      var arr = [];
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
      }
      var exportdata = {
        IDs: arr,
        SearchEntity: self.OrderPage.SearchEntity,
      };
      window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "ExportOrderALLS"
      ).value = JSON.stringify(exportdata);
      var fm = window.document.getElementById(
        self.OrderPage.GN("SearchOrder") + "ExportOrderALL"
      );
      fm.submit();
      //window.open((self.Urlpath == '/' ? '' : self.Urlpath) + '/Api/Order/ExportOrder?ArrID=' + arr.join(','))
    },

    ToCopyOrder() {
      self.OrderPage.IsCopyOrder = true;
    },
    CopyOrder() {
      if (self.CopyNo) {
        self.OrderPage.CopyOrder(self.CopyNo, function (d) {
          self.OrderPage.IsCopyOrder = true;
          self.OrderPage.SearchPageData();
        });
      } else {
        self.$message.error(gets("$请填写参考号/订单号"));
      }
    },
    ToOrderStatusByVoid() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.OrderStatusByVoid(arr, function (d) {
          self.OrderPage.SearchPageData();
        });
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    ToPrintPOrder() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        window.open(
          (self.Urlpath == "/" ? "" : self.Urlpath) +
            "/Labels/Printlabel.aspx?ID=" +
            arr.join(",")
        );
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    ToPrintOrderEUB() {},
    ToMarkingOrder() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        self.OrderPage.IsMarkingOrder = true;
      } else {
        self.$message.error(gets("$请选择一项订单"));
      }
    },
    MarkingOrder(Type, EnName, CnName) {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.MarkingOrder(arr, Type, EnName, CnName, function (d) {
          self.OrderPage.IsMarkingOrder = false;
          self.OrderPage.SearchPageData();
        });
      } else {
        self.$message.error(gets("$请选择一项订单"));
      }
    },
    ToRemarkOrder() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        self.OrderPage.IsRemarkOrder = true;
      } else {
        self.$message.error(gets("$请选择一项订单"));
      }
    },
    RemarkOrder() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.RemarkOrder(arr, self.Remark, function (d) {
          self.OrderPage.IsRemarkOrder = false;
          self.OrderPage.SearchPageData();
        });
      } else {
        self.$message.error(gets("$请选择一项订单"));
      }
    },
    ToPickUpOrder() {},
    ToOrderPaySubmit() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.OrderPaySubmit(
          arr,
          self.OrderPage.Table.IsSelectAll,
          self.OrderPage.SearchEntity,
          function (d) {
            self.OrderPage.SearchPageData();
          }
        );
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    ToCutOffOrder() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.CutOffOrder(
          arr,
          self.OrderPage.Table.IsSelectAll,
          self.OrderPage.SearchEntity,
          function (d) {
            self.OrderPage.SearchPageData();
          }
        );
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    ToGetUPSOrderTrackingNo() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.GetUPSOrderTrackingNo(
          arr,
          self.OrderPage.Table.IsSelectAll,
          self.OrderPage.SearchEntity,
          function (d) {
            self.OrderPage.SearchPageData();
          }
        );
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    ToPrintUPSOrder() {},
    ToDeleteOrder() {
      if (
        self.OrderTableSelectCheckbox &&
        self.OrderTableSelectCheckbox.length > 0
      ) {
        var arr = [];
        for (var i of self.OrderTableSelectCheckbox) {
          arr.push(i.ID);
        }
        self.OrderPage.DeleteOrder(
          arr,
          self.OrderPage.Table.IsSelectAll,
          self.OrderPage.SearchEntity,
          function (d) {
            self.OrderPage.SearchPageData();
          }
        );
      } else {
        self.$message.error(gets("$请选择至少一项订单"));
      }
    },
    UpdateTrackNos() {
      this.OrderPage.UploadTrackingNos.show();
    },
  },
};
</script>

<style>
.orderListTable .t-table:nth-child(1) {
  height: auto !important;
}
.orderListTable .t-table:nth-child(2) {
  height: auto !important;
}
.orderListTable .t-table:nth-child(3) {
  height: auto !important;
}
.orderListTable .t-table:nth-child(4) {
  height: auto !important;
}
.orderListTable .t-table:nth-child(5) {
  height: auto !important;
}
.orderListTable .t-table:nth-child(6) {
  height: auto !important;
}
.orderListBG th.gutter:last-of-type {
  display: block !important;
}

.checkbox-container {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-item {
  flex: 0 0 calc(20% - 20px); /* 20px为margin和padding的总和，保证每行显示5个选项 */
  margin-bottom: 10px;
  box-sizing: border-box;
}

label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.hidden-checkbox {
  position: absolute;
  opacity: 0;
}

.checkbox-custom {
  width: 16px;
  height: 16px;
  border: 2px solid #3498db;
  border-radius: 3px;
  margin-right: 8px;
  display: inline-block;
  background-color: white;
}

input[type="checkbox"]:checked + .checkbox-custom {
  background-color: #3498db;
  border: 2px solid #3498db;
}
</style>



// WEBPACK FOOTER //
// OrderList.vue?ea97632c